import React from 'react'

function ProfitLossDisbursementInfo() {
  return (
    <div>ProfitLossDisbursementInfo</div>
  )
}

export default ProfitLossDisbursementInfo